<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Actualizare Identificare</h1>
    </div>
    <form [formGroup]="form">
        <br>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Nume</mat-label>
                    <input type="text" matInput formControlName="last_name" />
                    <mat-error *ngIf="!form.controls['last_name'].valid && form.controls['last_name'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Prenume</mat-label>
                    <input type="text" matInput formControlName="first_name" />
                    <mat-error *ngIf="!form.controls['first_name'].valid && form.controls['first_name'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Data nașterii</mat-label>
                    <input matInput [matDatepicker]="birthDatePicker" [max]="maxDate" formControlName="birth_date"
                        readonly (focus)="birthDatePicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthDatePicker></mat-datepicker>
                    <mat-error *ngIf="!form.controls['birth_date'].valid && form.controls['birth_date'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>CNP</mat-label>
                    <input type="text" matInput formControlName="cnp" />
                    <mat-error *ngIf="form.controls['cnp'].hasError('required') && form.controls['cnp'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-error *ngIf="form.controls['cnp'].hasError('pattern') && form.controls['cnp'].touched">
                        CNP nevalid (13 cifre)
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Telefon</mat-label>
                    <input type="text" matInput formControlName="telefon" />
                    <mat-error *ngIf="form.controls['telefon'].hasError('pattern') && form.controls['telefon'].touched">
                        Telefon nevalid
                    </mat-error>
                </mat-form-field>

                <!-- <mat-form-field class="w-100" appearance="fill">
                    <button type="button" class="country-selector" mat-button matPrefix [matMenuTriggerFor]="menu">
                        <mat-icon class="expand-icon">expand_more</mat-icon>
                        {{ currentOption.flag }} {{ currentOption.dial_code }}
                    </button>
                    <mat-menu #menu="matMenu">
                        <button type="button" mat-menu-item (click)="changeCountry(optionRom)">
                            <span class="flag-wrapper">🇷🇴</span>
                            <span class="label-wrapper">
                                {{ optionRom.name }} {{ optionRom.dial_code }}
                            </span>
                        </button>
                        <mat-divider class="divider"></mat-divider>
                        <button type="button" mat-menu-item *ngFor="let option of options"
                            (click)="changeCountry(option)">
                            <span class="flag-wrapper">{{ option.flag }}</span>
                            <span class="label-wrapper">
                                {{ option.name }} {{ option.dial_code }}
                            </span>
                        </button>
                    </mat-menu>
                    <input type="text" matInput formControlName="telefon" />
                    <mat-error
                        *ngIf="form.controls['telefon'].hasError('required') && form.controls['telefon'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-error *ngIf="form.controls['telefon'].hasError('pattern') && form.controls['telefon'].touched">
                        Număr nevalid
                    </mat-error>
                </mat-form-field> -->
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Email</mat-label>
                    <input type="text" matInput formControlName="email" />
                    <mat-error *ngIf="form.controls['email'].hasError('required') && form.controls['email'].touched">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-error *ngIf="form.controls['email'].hasError('email') && form.controls['email'].touched">
                        Email nevalid
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Observații</mat-label>
                    <textarea matInput formControlName="observatii" rows="3"
                        placeholder="Adăugați observații..."></textarea>
                    <mat-hint align="end">{{ form.value.observatii?.length || 0 }}/500</mat-hint>
                    <mat-error *ngIf="form.controls['observatii'].hasError('maxlength')">
                        Maxim 500 caractere permise
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid"
                    (click)="submitForm()">
                    Actualizează
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-fixed" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>